import { useTranslation } from 'react-i18next';
import { Link } from '@inertiajs/react';
import { cn } from '../../lib/cn';

// `isCurrent` comes from the server and is keyed on the word id. It used to
// also fall back to a lemma comparison here, which lit up every POS sibling —
// a family holding both `burden`/noun and `burden`/verb highlighted both pills
// no matter which entry you were on.
export default function WordFamilyTree({ family, className }) {
  const { t } = useTranslation();
  if (!family) return null;

  return (
    <div className={cn('bg-gray-50 dark:bg-gray-800/50 rounded-lg p-4', className)}>
      <div className="flex items-center gap-2 mb-3">
        <span className="text-sm font-medium text-gray-500 dark:text-gray-400">
          {t('dictionary.headword')}
        </span>
        <span className="font-semibold text-gray-900 dark:text-white">
          {family.headword}
        </span>
        <span className="text-sm text-gray-500 dark:text-gray-400">
          ({family.size || family.members?.length || 0} {t('common.words')})
        </span>
      </div>
      <div className="flex flex-wrap gap-2">
        {family.members?.map((word) => (
          <Link
            key={word.id}
            href={`/teacher/dictionary/${word.id}`}
            className={cn(
              'px-3 py-1 text-sm rounded-full transition-colors',
              word.isCurrent
                ? 'bg-gray-900 text-white dark:bg-white dark:text-gray-900'
                : 'bg-white text-gray-700 hover:bg-gray-100 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 border border-gray-200 dark:border-gray-600'
            )}
          >
            {word.lemma}
            {word.pos && <span className="text-gray-400 ml-1 text-xs">({word.pos})</span>}
          </Link>
        ))}
      </div>
    </div>
  );
}
